var React = require('react');

class BeerNameTextbox extends React.Component {

    constructor() {
        super();
        this.onChange = this.onChange.bind(this);
        this.input = this.input.bind(this);
    }

    onChange(e){
        this.props.actions.changeSample(this.props.index, {
            ...this.props.sample,
            name: e.target.value
        })
    }

    input(){
        if (this.props.sample.selection == 'new_beer') {
            return (
                <input
                    type='text'
                    className='form-input'
                    name={`beer-name-${this.props.index}`}
                    id={`beer-name-${this.props.index}`}
                    onChange={this.onChange}
                    placeholder='Name of new product'
                />
            )
        }
    }

    render() {
            return (
                <div>
                    {this.input()}
                </div>
            )
    }
}

export default BeerNameTextbox